import { CommonEnums } from '../../common.enums';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { Splt_Inst_CndsUtil } from 'src/app/shared/utils/splt_inst_cnds.util';
import { Splt_Inst } from './splt_inst';
import { Splt_Inst_Cnd } from './splt_inst_cnd';

export class Splitter {
    splt_Inst: Splt_Inst;
    splt_Inst_Cnds: Array<Splt_Inst_Cnd>;

    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: String;
    fldr_Id: number;
    is_In_SubFlow: string;
    interactive_Cnd_ID: number;
    sel_Run_PropertyType_Cd: string;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    conditions_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.splt_Inst = new Splt_Inst();
        this.splt_Inst_Cnds = new Array<Splt_Inst_Cnd>();
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_EMPTY;
        this.interactive_Cnd_ID = CommonEnums.defaults.LONG_VAL;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.conditions_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(splitterTmp: Splitter): Splitter {
        let splitter: Splitter = new Splitter();
        splitter.copyFrom(splitterTmp);
        return splitter;
    }

    copy(): Splitter {
        let splitterTmp: Splitter = new Splitter();

        splitterTmp.splt_Inst = this.splt_Inst.copy();

        splitterTmp.splt_Inst_Cnds = Splt_Inst_CndsUtil.getInstance().copy(this.splt_Inst_Cnds);
        splitterTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        splitterTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        splitterTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        splitterTmp.ref_Id = this.ref_Id;
        splitterTmp.ref_Cd = this.ref_Cd;
        splitterTmp.fldr_Id = this.fldr_Id;
        splitterTmp.is_In_SubFlow = this.is_In_SubFlow;
        splitterTmp.interactive_Cnd_ID = this.interactive_Cnd_ID;
        splitterTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;

        splitterTmp.change_Ind = this.change_Ind;
        splitterTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        splitterTmp.conditions_Tab_Change_Ind = this.conditions_Tab_Change_Ind;
        splitterTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        splitterTmp.error_Cd = this.error_Cd;
        splitterTmp.error_Msg = this.error_Msg;

        return splitterTmp;
    }

    copyFrom(splitterTmp: Splitter): void {
        this.splt_Inst.copyFrom(splitterTmp.splt_Inst);

        Splt_Inst_CndsUtil.getInstance().copyFrom(this.splt_Inst_Cnds, splitterTmp.splt_Inst_Cnds);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, splitterTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, splitterTmp.runPropertyTypes);

        this.nativeDbTyp_Id = splitterTmp.nativeDbTyp_Id;
        this.ref_Id = splitterTmp.ref_Id;
        this.ref_Cd = splitterTmp.ref_Cd;
        this.fldr_Id = splitterTmp.fldr_Id;
        this.is_In_SubFlow = splitterTmp.is_In_SubFlow;
        this.interactive_Cnd_ID = splitterTmp.interactive_Cnd_ID;
        this.sel_Run_PropertyType_Cd = splitterTmp.sel_Run_PropertyType_Cd;

        this.change_Ind = splitterTmp.change_Ind;
        this.gen_Tab_Change_Ind = splitterTmp.gen_Tab_Change_Ind;
        this.conditions_Tab_Change_Ind = splitterTmp.conditions_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = splitterTmp.rProp_Tab_Change_Ind;

        this.error_Cd = splitterTmp.error_Cd;
        this.error_Msg = splitterTmp.error_Msg;
    }

    compare(splitterTmp: Splitter): string {
        let diffString: string = this.splt_Inst.compare(splitterTmp.splt_Inst);
        if (diffString != '') return diffString;

        diffString = this.toBaseCompare(splitterTmp);
        if (diffString != '') return diffString;

        diffString = Splt_Inst_CndsUtil.getInstance().compare(this.splt_Inst_Cnds, splitterTmp.splt_Inst_Cnds);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, splitterTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, splitterTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(splitterTmp: Splitter): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = splitterTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toBaseString(): string {
        return ", interactive_Cnd_ID =" + this.interactive_Cnd_ID +
            ", is_In_SubFlow =" + this.is_In_SubFlow + ", sel_Run_PropertyType_Cd =" + this.sel_Run_PropertyType_Cd;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Spliter [splt_Inst =" + this.splt_Inst.toString() +
            ", splt_Inst_Cnds=" + Splt_Inst_CndsUtil.getInstance().toString(this.splt_Inst_Cnds) +
            ", run_Properties =" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes =" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
                ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", ref_Id =" + this.ref_Id + ", ref_Cd =" + this.ref_Cd + ", fldr_Id =" + this.fldr_Id +
                ", gen_Tab_Change_Ind =" + this.gen_Tab_Change_Ind +
                ", conditions_Tab_Change_Ind =" + this.conditions_Tab_Change_Ind +
                ", rProp_Tab_Change_Ind =" + this.rProp_Tab_Change_Ind;
        }

        str += ']';
        return str;
    }
}